import React from "react";

export default function PrivacyPolicy() {
  return (
    <>
      <h2 style={{ textAlign: "center", marginBottom: "20px" }}>
        Aviso de Privacidad Prospectos y/o Colaboradores
      </h2>
      <p>
        En cumplimiento de la Ley Federal de Protección de Datos Personales en
        Posesión de los Particulares, se pone a su disposición el presente Aviso
        de Privacidad relacionado con los datos personales de los Prospectos y/o
        Colaboradores (en adelante el “Titular”), recabados por LEGABOT S.A. de
        C.V., sus filiales y subsidiarias (en adelante “LEGABOT”).
      </p>

      <h3>1. Generales</h3>
      <p>
        LEGABOT es una persona moral comprometida y respetuosa de los derechos
        sobre los datos personales reconocidos en el artículo 16, párrafo II de
        la Constitución Política de los Estados Unidos Mexicanos, así como de
        las disposiciones de la Ley Federal de Protección de Datos Personales en
        Posesión de los Particulares.
      </p>

      <h3>2. Definiciones</h3>
      <ul>
        <li>
          <strong>Datos personales:</strong> Cualquier información concerniente
          a una persona física identificada o identificable.
        </li>
        <li>
          <strong>Datos personales sensibles:</strong> Aquellos que afecten la
          esfera íntima del TITULAR o cuya indebida utilización pueda dar origen
          a discriminación.
        </li>
        <li>
          <strong>Titular:</strong> La persona física a quien corresponden los
          datos personales.
        </li>
        <li>
          <strong>Responsable:</strong> LEGABOT, quien decide sobre el tratamiento
          de los datos.
        </li>
        <li>
          <strong>Encargado:</strong> Persona física o moral que trata datos
          personales por cuenta del Responsable.
        </li>
        <li>
          <strong>Tratamiento:</strong> Obtención, uso, divulgación o
          almacenamiento de datos personales.
        </li>
        <li>
          <strong>Derechos ARCO:</strong> Acceso, Rectificación, Cancelación y
          Oposición.
        </li>
      </ul>

      <h3>3. Identidad y Domicilio del Responsable</h3>
      <p>
        LEGABOT S.A. DE C.V., con domicilio en Ave. León #119, Piso 4, colonia
        Jardines del Moral, León, Guanajuato, México, C.P. 37160. Portal web:{" "}
        <a href="https://www.optimen.com.mx" target="_blank" rel="noreferrer">
          www.optimen.com.mx
        </a>
      </p>

      <h3>4. Datos que se recaban</h3>
      <p>
        LEGABOT obtiene directamente datos sensibles y no sensibles del TITULAR,
        tales como:
      </p>
      <ul>
        <li>
          <strong>Generales:</strong> Nombre, dirección, teléfonos, correo,
          estado civil, CURP, NSS, fotografías.
        </li>
        <li>
          <strong>Académicos:</strong> Nivel de estudios, idiomas, cursos.
        </li>
        <li>
          <strong>Referencias:</strong> Personales y laborales.
        </li>
        <li>
          <strong>Familiares:</strong> Nombres y ocupación.
        </li>
        <li>
          <strong>Médicos:</strong> Estado de salud, enfermedades, hábitos.
        </li>
        <li>
          <strong>Económicos:</strong> Cuentas, ingresos, egresos, propiedades.
        </li>
      </ul>

      <h3>5. Finalidades del Tratamiento</h3>
      <p>
        LEGABOT podrá tratar los datos personales para las siguientes finalidades
        primarias:
      </p>
      <ul>
        <li>Trámites de selección y contratación.</li>
        <li>Validación de información personal.</li>
        <li>Elaboración de expedientes laborales.</li>
        <li>Cumplimiento de obligaciones fiscales y laborales.</li>
      </ul>
      <p>
        Finalidades secundarias: envío de felicitaciones y comunicados internos.
      </p>

      <h3>6. Medidas de Seguridad</h3>
      <p>
        LEGABOT implementa medidas administrativas, legales, técnicas y físicas
        como uso de firewalls, antivirus, accesos personalizados, contratos de
        confidencialidad y mantenimiento de equipos de respaldo.
      </p>

      <h3>7. Derechos ARCO y Revocación del Consentimiento</h3>
      <p>
        El TITULAR puede acceder, rectificar, cancelar u oponerse al tratamiento
        de sus datos, o bien revocar su consentimiento, enviando una solicitud al
        correo:{" "}
        <a href="mailto:admin@optimen.com.mx">admin@optimen.com.mx</a>.
      </p>

      <h3>8. Transferencias</h3>
      <p>
        LEGABOT podrá transferir datos al IMSS, INFONAVIT, SAT e instituciones
        bancarias, únicamente para cumplir con obligaciones legales.
      </p>

      <h3>9. Modificaciones</h3>
      <p>
        LEGABOT podrá modificar el presente Aviso y lo mantendrá actualizado en
        todo momento conforme a la normativa aplicable.
      </p>

      <h3>10. Autoridad Garante</h3>
      <p>
        En caso de considerar vulnerados sus derechos, EL TITULAR podrá acudir al
        Instituto Nacional de Transparencia, Acceso a la Información y Protección
        de Datos Personales (INAI) –{" "}
        <a href="https://www.inai.org.mx" target="_blank" rel="noreferrer">
          www.inai.org.mx
        </a>
      </p>

      <h3>11. Jurisdicción</h3>
      <p>
        Este aviso se rige por las leyes mexicanas, sometiéndose a los Tribunales
        del Estado de Guanajuato.
      </p>

      <p style={{ marginTop: "20px", fontWeight: "bold" }}>
        Fecha de última actualización: 13 de diciembre del 2021
      </p>

      <p style={{ textAlign: "center", marginTop: "20px" }}>
        Consiento y autorizo que mis datos personales sensibles sean tratados por
        LEGABOT S.A. DE C.V. conforme al presente aviso de privacidad.
      </p>
    </>
  );
}
